import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Fade, Modal } from '@mui/material';
import useStyles from './styles';
import SingleGroup from './SingleGroup';
import { viewedProductGroupCustom } from '../../../../../utils/custom_prop_types/customPropTypes';

export default function GroupModal({
  modals,
  setOpenModal,
  setErrorMessage,
  viewedProductGroup,
}) {
  const classes = useStyles();

  const handleModalClose = () => {
    setErrorMessage([]);
    setOpenModal('adminAssociationsGroup', false);
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={modals.adminAssociationsGroup}
      closeAfterTransition
    >
      <Fade in={modals.adminAssociationsGroup}>
        <div className={classes.paper}>
          <div className={classes.topBarWrapper}>
            <div>
              <h2 id="transition-modal-title">
                {`Group ${viewedProductGroup?.number}`}
              </h2>
            </div>
            <IconButton
              color="secondary"
              aria-label="close"
              className={classes.closeButton}
              onClick={() => handleModalClose()}
              size="large"
            >
              <CloseIcon />
            </IconButton>
          </div>
          <SingleGroup />
        </div>
      </Fade>
    </Modal>
  );
}

GroupModal.propTypes = {
  modals: PropTypes.objectOf(PropTypes.bool).isRequired,
  setOpenModal: PropTypes.func.isRequired,
  setErrorMessage: PropTypes.func.isRequired,
  viewedProductGroup: viewedProductGroupCustom.isRequired,
};
